var _rect, _rect2, _rect3, _rect4, _rect5, _g, _circle, _rect6, _rect7, _g2, _circle2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _g9, _g10, _g11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpsellHeatmap = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 169,
    viewBox: "0 0 156 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90.208,
    y: 11.8698,
    width: 23.889,
    height: 2.31184,
    rx: 1.15592,
    fill: "#8F8B8F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.309,
    y: 18.4882,
    width: 23.889,
    height: 2.31184,
    rx: 1.15592,
    fill: "#8F8B8F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9333,
    height: 2.12258,
    rx: 1.06129,
    transform: "matrix(-1 0 0 1 55.2715 121.311)",
    fill: "#8F8B8F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 26.886,
    height: 2.12258,
    rx: 1.06129,
    transform: "matrix(-1 0 0 1 46.7812 129.093)",
    fill: "#8F8B8F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.6129,
    height: 2.12258,
    rx: 1.06129,
    transform: "matrix(-1 0 0 1 60.9316 129.093)",
    fill: "#8F8B8F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5301_74201)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5.6602,
    transform: "matrix(-1 0 0 1 6.11909 110.969)",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4.91544,
    transform: "matrix(-1 0 0 1 6.11909 110.969)",
    stroke: "#8F8B8F",
    strokeWidth: 1.48953
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12258,
    height: 12.0279,
    rx: 1.06129,
    transform: "matrix(-1 0 0 1 144.046 132.11)",
    fill: "#8F8B8F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12258,
    height: 12.0279,
    rx: 1.06129,
    transform: "matrix(0 -1 -1 0 148.999 139.186)",
    fill: "#8F8B8F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5301_74201)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5.6602,
    transform: "matrix(-1 0 0 1 149.456 45.6252)",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4.91544,
    transform: "matrix(-1 0 0 1 149.456 45.6252)",
    stroke: "#8F8B8F",
    strokeWidth: 1.48953
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_5301_74201)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.876,
    y: 65.8699,
    width: 20.6971,
    height: 44.0104,
    rx: 8.98097,
    transform: "rotate(5.32252 112.876 65.8699)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 66.8474,
    width: 18.901,
    height: 42.2142,
    rx: 8.08287,
    transform: "rotate(5.32252 113.687 66.8474)",
    stroke: "#8F8B8F",
    strokeWidth: 1.79619
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_5301_74201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-1_5301_74201",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.692 98.6746C107.339 100.336 109.382 110.299 106.255 120.928C105.702 122.805 105.026 124.577 104.255 126.213C104.745 128.54 105.008 131.082 104.996 133.745C104.944 144.824 100.13 153.783 94.2438 153.755C88.3574 153.728 83.6274 144.724 83.6792 133.645C83.6909 131.132 83.9476 128.728 84.4062 126.514C84.1579 123.042 84.5936 119.026 85.8043 114.911C88.9314 104.283 96.0443 97.0132 101.692 98.6746Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.692 98.6746C107.339 100.336 109.382 110.299 106.255 120.928C105.702 122.805 105.026 124.577 104.255 126.213C104.745 128.54 105.008 131.082 104.996 133.745C104.944 144.824 100.13 153.783 94.2438 153.755C88.3574 153.728 83.6274 144.724 83.6792 133.645C83.6909 131.132 83.9476 128.728 84.4062 126.514C84.1579 123.042 84.5936 119.026 85.8043 114.911C88.9314 104.283 96.0443 97.0132 101.692 98.6746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.255 120.928L107.978 121.435L107.978 121.435L106.255 120.928ZM101.692 98.6746L102.198 96.9515L101.692 98.6746ZM104.255 126.213L102.498 126.583L102.374 125.993L102.63 125.448L104.255 126.213ZM104.996 133.745L103.2 133.736L104.996 133.745ZM94.2438 153.755L94.2522 151.959L94.2438 153.755ZM83.6792 133.645L81.883 133.637L81.883 133.637L83.6792 133.645ZM84.4062 126.514L86.1978 126.386L86.2156 126.634L86.1651 126.878L84.4062 126.514ZM85.8043 114.911L84.0811 114.404L84.0811 114.404L85.8043 114.911ZM104.531 120.421C106.029 115.331 106.26 110.485 105.504 106.799C104.73 103.026 103.059 100.949 101.185 100.398L102.198 96.9515C105.972 98.0616 108.145 101.797 109.023 106.078C109.919 110.446 109.607 115.896 107.978 121.435L104.531 120.421ZM102.63 125.448C103.361 123.897 104.005 122.211 104.531 120.421L107.978 121.435C107.4 123.399 106.691 125.257 105.88 126.979L102.63 125.448ZM103.2 133.736C103.212 131.196 102.96 128.781 102.498 126.583L106.013 125.844C106.53 128.299 106.805 130.969 106.792 133.753L103.2 133.736ZM94.2522 151.959C96.2056 151.968 98.4025 150.458 100.226 147.065C102.007 143.75 103.175 139.042 103.2 133.736L106.792 133.753C106.765 139.527 105.501 144.837 103.39 148.765C101.322 152.615 98.1685 155.57 94.2355 155.552L94.2522 151.959ZM85.4753 133.653C85.4505 138.959 86.575 143.678 88.3248 147.009C90.1161 150.419 92.2988 151.95 94.2522 151.959L94.2355 155.552C90.3024 155.533 87.1769 152.549 85.1445 148.68C83.0707 144.732 81.856 139.41 81.883 133.637L85.4753 133.653ZM86.1651 126.878C85.7315 128.972 85.4865 131.256 85.4753 133.653L81.883 133.637C81.8953 131.008 82.1637 128.485 82.6474 126.15L86.1651 126.878ZM87.5275 115.418C86.3707 119.35 85.9664 123.15 86.1978 126.386L82.6146 126.642C82.3494 122.933 82.8166 118.703 84.0811 114.404L87.5275 115.418ZM101.185 100.398C99.3105 99.8464 96.7805 100.687 94.0867 103.44C91.4553 106.13 89.0249 110.329 87.5275 115.418L84.0811 114.404C85.7107 108.865 88.4004 104.115 91.519 100.928C94.5752 97.8045 98.4253 95.8414 102.198 96.9515L101.185 100.398Z",
    fill: "#8F8B8F",
    mask: "url(#path-14-inside-1_5301_74201)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_5301_74201)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 7.9894,
    ry: 27.6635,
    transform: "matrix(-0.519018 0.854763 0.854763 0.519018 78.338 73.3117)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6575 79.3731C81.136 83.3069 87.4335 86.0914 92.3608 87.4262C94.8305 88.0953 96.905 88.3859 98.4636 88.3026C100.058 88.2174 100.878 87.7606 101.216 87.2034C101.554 86.6462 101.582 85.708 100.922 84.2542C100.277 82.8329 99.0622 81.1263 97.3294 79.2435C93.8724 75.4873 88.4971 71.1841 82.0185 67.2503C75.54 63.3165 69.2426 60.5319 64.3152 59.1971C61.8455 58.5281 59.771 58.2375 58.2124 58.3208C56.6182 58.406 55.7982 58.8627 55.4599 59.4199C55.1216 59.9771 55.0945 60.9154 55.7542 62.3692C56.3992 63.7905 57.6139 65.4971 59.3466 67.3798C62.8036 71.1361 68.179 75.4393 74.6575 79.3731Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.79619
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_5301_74201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-2_5301_74201",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.551 121.394C92.0897 118.627 84.0374 107.797 82.1609 93.9734C79.8396 76.8742 87.8464 61.6703 100.045 60.0144C108.539 58.8613 116.825 64.5817 121.858 73.9358C125.476 76.4533 129.68 81.4114 133.188 87.6923C139.047 98.1858 140.744 108.398 136.976 110.502C134.393 111.944 129.91 109.198 125.458 103.945C124.625 107.091 123.404 109.967 121.859 112.457C122.751 115.782 123.094 119.746 122.719 123.952C122.48 126.633 121.971 129.166 121.254 131.456C121.658 133.127 121.955 134.898 122.124 136.74C123.141 147.772 119.214 157.154 113.352 157.694C107.49 158.234 101.914 149.729 100.897 138.696C100.552 134.949 100.777 131.393 101.454 128.309C101.29 126.326 101.293 124.224 101.486 122.059C101.506 121.836 101.528 121.615 101.551 121.394Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.551 121.394C92.0897 118.627 84.0374 107.797 82.1609 93.9734C79.8396 76.8742 87.8464 61.6703 100.045 60.0144C108.539 58.8613 116.825 64.5817 121.858 73.9358C125.476 76.4533 129.68 81.4114 133.188 87.6923C139.047 98.1858 140.744 108.398 136.976 110.502C134.393 111.944 129.91 109.198 125.458 103.945C124.625 107.091 123.404 109.967 121.859 112.457C122.751 115.782 123.094 119.746 122.719 123.952C122.48 126.633 121.971 129.166 121.254 131.456C121.658 133.127 121.955 134.898 122.124 136.74C123.141 147.772 119.214 157.154 113.352 157.694C107.49 158.234 101.914 149.729 100.897 138.696C100.552 134.949 100.777 131.393 101.454 128.309C101.29 126.326 101.293 124.224 101.486 122.059C101.506 121.836 101.528 121.615 101.551 121.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1609 93.9734L83.9407 93.7318L83.9407 93.7318L82.1609 93.9734ZM101.551 121.394L102.055 119.671L103.496 120.092L103.337 121.585L101.551 121.394ZM100.045 60.0144L99.8029 58.2345L99.8029 58.2345L100.045 60.0144ZM121.858 73.9358L120.833 75.4102L120.48 75.1649L120.277 74.7869L121.858 73.9358ZM133.188 87.6923L134.756 86.8166L134.756 86.8166L133.188 87.6923ZM136.976 110.502L137.852 112.07L137.852 112.07L136.976 110.502ZM125.458 103.945L123.722 103.485L124.603 100.158L126.828 102.784L125.458 103.945ZM121.859 112.457L120.124 112.923L119.923 112.171L120.333 111.51L121.859 112.457ZM122.719 123.952L124.508 124.112L124.508 124.112L122.719 123.952ZM121.254 131.456L119.508 131.879L119.391 131.395L119.54 130.92L121.254 131.456ZM122.124 136.74L120.336 136.905L120.336 136.905L122.124 136.74ZM113.352 157.694L113.187 155.906L113.187 155.906L113.352 157.694ZM100.897 138.696L99.1088 138.861L99.1088 138.861L100.897 138.696ZM101.454 128.309L103.244 128.16L103.267 128.43L103.209 128.694L101.454 128.309ZM101.486 122.059L99.6969 121.899L99.6969 121.899L101.486 122.059ZM83.9407 93.7318C85.7581 107.119 93.4996 117.168 102.055 119.671L101.047 123.118C90.6799 120.087 82.3168 108.475 80.381 94.215L83.9407 93.7318ZM100.286 61.7942C94.9121 62.5238 90.2922 66.2576 87.2472 72.0396C84.2043 77.8177 82.8246 85.5099 83.9407 93.7318L80.381 94.215C79.1759 85.3377 80.6389 76.8783 84.0687 70.3657C87.4963 63.857 92.9789 59.1609 99.8029 58.2345L100.286 61.7942ZM120.277 74.7869C115.439 65.7969 107.754 60.7805 100.286 61.7942L99.8029 58.2345C109.324 56.942 118.211 63.3666 123.44 73.0847L120.277 74.7869ZM131.619 88.568C128.188 82.4236 124.148 77.7168 120.833 75.4102L122.884 72.4614C126.805 75.1898 131.172 80.3992 134.756 86.8166L131.619 88.568ZM136.101 108.933C136.405 108.763 136.811 108.317 137.035 107.179C137.258 106.05 137.243 104.483 136.92 102.537C136.277 98.6625 134.476 93.6829 131.619 88.568L134.756 86.8166C137.759 92.1952 139.736 97.5684 140.464 101.949C140.827 104.131 140.896 106.167 140.56 107.873C140.226 109.569 139.431 111.188 137.852 112.07L136.101 108.933ZM126.828 102.784C128.979 105.322 131.061 107.159 132.82 108.182C134.675 109.26 135.675 109.171 136.101 108.933L137.852 112.07C135.694 113.275 133.16 112.534 131.015 111.287C128.774 109.985 126.388 107.821 124.088 105.107L126.828 102.784ZM120.333 111.51C121.776 109.185 122.93 106.475 123.722 103.485L127.194 104.405C126.32 107.706 125.033 110.749 123.385 113.404L120.333 111.51ZM120.93 123.793C121.288 119.774 120.956 116.023 120.124 112.923L123.594 111.991C124.546 115.54 124.9 119.718 124.508 124.112L120.93 123.793ZM119.54 130.92C120.217 128.756 120.702 126.351 120.93 123.793L124.508 124.112C124.258 126.916 123.725 129.575 122.968 131.993L119.54 130.92ZM120.336 136.905C120.174 135.148 119.891 133.463 119.508 131.879L123 131.034C123.425 132.791 123.735 134.648 123.913 136.575L120.336 136.905ZM113.187 155.906C115.132 155.726 117.173 154.011 118.661 150.458C120.114 146.987 120.823 142.188 120.336 136.905L123.913 136.575C124.443 142.324 123.697 147.732 121.975 151.845C120.287 155.876 117.434 159.122 113.517 159.483L113.187 155.906ZM102.686 138.531C103.173 143.815 104.747 148.404 106.81 151.55C108.922 154.772 111.242 156.085 113.187 155.906L113.517 159.483C109.601 159.844 106.202 157.174 103.806 153.52C101.361 149.791 99.6388 144.611 99.1088 138.861L102.686 138.531ZM103.209 128.694C102.574 131.584 102.356 134.954 102.686 138.531L99.1088 138.861C98.7479 134.945 98.9799 131.202 99.7 127.923L103.209 128.694ZM103.275 122.218C103.091 124.284 103.089 126.282 103.244 128.16L99.6643 128.457C99.4913 126.369 99.4949 124.165 99.6969 121.899L103.275 122.218ZM103.337 121.585C103.315 121.795 103.294 122.006 103.275 122.218L99.6969 121.899C99.7177 121.666 99.7404 121.435 99.765 121.204L103.337 121.585Z",
    fill: "#8F8B8F",
    mask: "url(#path-18-inside-2_5301_74201)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_5301_74201)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 101.677,
    cy: 54.6911,
    r: 25.0203,
    transform: "rotate(42.5986 101.677 54.6911)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.677,
    cy: 54.6911,
    r: 24.1222,
    transform: "rotate(42.5986 101.677 54.6911)",
    stroke: "#8F8B8F",
    strokeWidth: 1.79619
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_5301_74201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.445 54.4404C109.26 64.8739 100.946 72.4967 91.8739 71.4663C82.8023 70.4359 76.4089 61.1427 77.594 50.7092C78.779 40.2757 86.1948 40.567 95.2665 41.5973C104.338 42.6277 111.63 44.007 110.445 54.4404Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.553 54.3391C108.41 64.401 100.441 71.5355 91.9753 70.5739C83.5096 69.6124 77.3435 60.8725 78.4863 50.8105C78.7713 48.3021 79.4218 46.5216 80.3136 45.2564C81.1967 44.0036 82.3563 43.1988 83.7706 42.7016C86.6779 41.6794 90.585 41.9695 95.1651 42.4897C99.7452 43.0099 103.618 43.6035 106.222 45.2516C107.489 46.0534 108.438 47.0977 109.018 48.5166C109.603 49.9496 109.838 51.8307 109.553 54.3391Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.79619
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.569 52.2241C103.383 53.6947 102.836 54.9359 102.15 55.7578C101.457 56.5889 100.715 56.8989 100.089 56.8196C99.4636 56.7403 98.8225 56.255 98.3583 55.2773C97.8992 54.3103 97.6794 52.972 97.8658 51.5015C98.0521 50.0309 98.5988 48.7897 99.2845 47.9678C99.978 47.1368 100.72 46.8267 101.346 46.906C101.971 46.9853 102.612 47.4706 103.076 48.4483C103.536 49.4153 103.755 50.7536 103.569 52.2241Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.79619
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4076 49.83C87.2473 51.0945 86.7778 52.1558 86.1956 52.8536C85.6057 53.5606 84.9938 53.8023 84.5 53.7397C84.0063 53.6771 83.474 53.2905 83.0791 52.4587C82.6893 51.6378 82.4993 50.4928 82.6596 49.2283C82.8198 47.9638 83.2893 46.9025 83.8716 46.2047C84.4615 45.4977 85.0734 45.256 85.5671 45.3186C86.0609 45.3812 86.5931 45.7678 86.9881 46.5996C87.3778 47.4205 87.5678 48.5655 87.4076 49.83Z",
    fill: "white",
    stroke: "#8F8B8F",
    strokeWidth: 1.79619
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_di_5301_74201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-3_5301_74201",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.328 24.7609C133.837 23.0088 132.829 21.1756 131.077 20.6665C129.325 20.1573 127.492 21.1649 126.983 22.917L126.556 24.3872C126.159 25.7501 126.681 27.162 127.757 27.9617C127.688 28.0597 127.633 28.1706 127.598 28.2924L122.146 47.0534C119.666 47.039 117.375 48.6593 116.649 51.1592L115.912 53.6928C115.035 56.7121 116.771 59.8711 119.791 60.7485C122.81 61.6259 125.969 59.8896 126.846 56.8703L127.583 54.3367C128.398 51.5289 126.954 48.6004 124.32 47.4982L129.722 28.9095C129.75 28.8109 129.765 28.7115 129.766 28.6136C131.184 28.5979 132.484 27.6632 132.901 26.2311L133.328 24.7609Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.328 24.7609C133.837 23.0088 132.829 21.1756 131.077 20.6665C129.325 20.1573 127.492 21.1649 126.983 22.917L126.556 24.3872C126.159 25.7501 126.681 27.162 127.757 27.9617C127.688 28.0597 127.633 28.1706 127.598 28.2924L122.146 47.0534C119.666 47.039 117.375 48.6593 116.649 51.1592L115.912 53.6928C115.035 56.7121 116.771 59.8711 119.791 60.7485C122.81 61.6259 125.969 59.8896 126.846 56.8703L127.583 54.3367C128.398 51.5289 126.954 48.6004 124.32 47.4982L129.722 28.9095C129.75 28.8109 129.765 28.7115 129.766 28.6136C131.184 28.5979 132.484 27.6632 132.901 26.2311L133.328 24.7609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.077 20.6664L130.576 22.3912L131.077 20.6664ZM133.328 24.7608L131.603 24.2596L133.328 24.7608ZM126.983 22.9169L125.258 22.4157L125.258 22.4157L126.983 22.9169ZM126.556 24.3872L128.28 24.8884L128.28 24.8884L126.556 24.3872ZM127.757 27.9617L128.829 26.5201L130.237 27.5671L129.223 28.9996L127.757 27.9617ZM127.598 28.2923L125.873 27.7911L125.873 27.7911L127.598 28.2923ZM122.146 47.0534L123.871 47.5546L123.492 48.8574L122.135 48.8495L122.146 47.0534ZM116.649 51.1591L114.924 50.6579L114.924 50.6579L116.649 51.1591ZM115.912 53.6927L117.637 54.194L117.637 54.194L115.912 53.6927ZM119.791 60.7484L119.289 62.4733L119.289 62.4733L119.791 60.7484ZM126.846 56.8702L128.571 57.3715L128.571 57.3715L126.846 56.8702ZM127.583 54.3366L129.307 54.8379L129.307 54.8379L127.583 54.3366ZM124.32 47.4981L123.626 49.1551L122.148 48.5364L122.595 46.9969L124.32 47.4981ZM129.722 28.9095L131.447 29.4107L131.447 29.4107L129.722 28.9095ZM129.766 28.6135L127.97 28.592L127.991 26.8368L129.746 26.8174L129.766 28.6135ZM132.901 26.2311L131.176 25.7298L131.176 25.7298L132.901 26.2311ZM131.579 18.9416C134.283 19.7276 135.839 22.5574 135.053 25.2621L131.603 24.2596C131.835 23.4601 131.376 22.6236 130.576 22.3912L131.579 18.9416ZM125.258 22.4157C126.044 19.711 128.874 18.1556 131.579 18.9416L130.576 22.3912C129.777 22.1589 128.94 22.6187 128.708 23.4182L125.258 22.4157ZM124.831 23.8859L125.258 22.4157L128.708 23.4182L128.28 24.8884L124.831 23.8859ZM126.686 29.4033C125.027 28.1706 124.219 25.9925 124.831 23.8859L128.28 24.8884C128.101 25.5076 128.335 26.1534 128.829 26.5201L126.686 29.4033ZM129.223 28.9996C129.268 28.9365 129.302 28.8665 129.323 28.7936L125.873 27.7911C125.965 27.4747 126.108 27.1827 126.291 26.9237L129.223 28.9996ZM129.323 28.7936L123.871 47.5546L120.421 46.5521L125.873 27.7911L129.323 28.7936ZM114.924 50.6579C115.88 47.3668 118.895 45.2382 122.156 45.2572L122.135 48.8495C120.437 48.8396 118.87 49.9517 118.374 51.6604L114.924 50.6579ZM114.188 53.1915L114.924 50.6579L118.374 51.6604L117.637 54.194L114.188 53.1915ZM119.289 62.4733C115.317 61.319 113.033 57.1634 114.188 53.1915L117.637 54.194C117.037 56.2607 118.225 58.423 120.292 59.0236L119.289 62.4733ZM128.571 57.3715C127.417 61.3434 123.261 63.6275 119.289 62.4733L120.292 59.0236C122.359 59.6242 124.521 58.4357 125.122 56.369L128.571 57.3715ZM129.307 54.8379L128.571 57.3715L125.122 56.369L125.858 53.8354L129.307 54.8379ZM125.013 45.8411C128.48 47.2918 130.381 51.1431 129.307 54.8379L125.858 53.8354C126.416 51.9146 125.428 49.9089 123.626 49.1551L125.013 45.8411ZM122.595 46.9969L127.997 28.4082L131.447 29.4107L126.045 47.9994L122.595 46.9969ZM127.997 28.4082C127.98 28.467 127.971 28.5291 127.97 28.592L131.562 28.635C131.559 28.8938 131.521 29.1546 131.447 29.4107L127.997 28.4082ZM134.625 26.7323C133.982 28.9455 131.973 30.3854 129.786 30.4096L129.746 26.8174C130.394 26.8103 130.987 26.3807 131.176 25.7298L134.625 26.7323ZM135.053 25.2621L134.625 26.7323L131.176 25.7298L131.603 24.2596L135.053 25.2621Z",
    fill: "#8F8B8F",
    mask: "url(#path-26-inside-3_5301_74201)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_bi_5301_74201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2945 5.46925C73.3515 3.08634 71.1146 1.30965 68.8064 1.90464L7.42138 17.7286C5.83461 18.1377 4.72573 19.5687 4.72573 21.2073V76.6955C4.72573 78.2281 5.69803 79.5919 7.14688 80.0916L66.3369 100.505C68.6355 101.298 71.0413 99.6255 71.0995 97.1947L73.2945 5.46925Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0306 2.77431L7.64557 18.5983C6.45549 18.9051 5.62383 19.9783 5.62383 21.2073V76.6955C5.62383 77.8449 6.35305 78.8678 7.43969 79.2425L66.6297 99.6558C68.3537 100.25 70.158 98.9963 70.2016 97.1732L72.3967 5.44776C72.4394 3.66058 70.7617 2.32806 69.0306 2.77431Z",
    stroke: "#AEAEAE",
    strokeWidth: 1.79619
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_bi_5301_74201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7461 99.4921C43.7461 97.9973 42.8204 96.6586 41.4217 96.131L19.8228 87.9825C18.0476 87.3127 16.1505 88.6247 16.1505 90.5221V90.5221C16.1505 91.5409 16.721 92.4739 17.6279 92.9382L38.5168 103.631C40.9072 104.855 43.7461 103.119 43.7461 100.434V99.4921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1047 96.9713L19.5058 88.8228C18.3179 88.3746 17.0486 89.2525 17.0486 90.5221C17.0486 91.2038 17.4303 91.8281 18.0372 92.1388L38.926 102.832C40.7188 103.75 42.848 102.448 42.848 100.434V99.4921C42.848 98.371 42.1537 97.367 41.1047 96.9713Z",
    stroke: "#8F8B8F",
    strokeWidth: 1.79619
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5301_74201",
    x: 0.458984,
    y: 105.308,
    width: 15.0441,
    height: 12.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72382,
    dy: 1.48953
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24524
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.811438 0 0 0 0 0.157674 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5301_74201",
    x: 143.796,
    y: 39.965,
    width: 15.0441,
    height: 12.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.72382,
    dy: 1.48953
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86191
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.854902 0 0 0 0 0.545098 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_5301_74201",
    x: 100.406,
    y: 59.3186,
    width: 41.4662,
    height: 62.5156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.83627
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.59067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5301_74201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5301_74201",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.18477,
    dy: 1.79619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38858
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.29245 0 0 0 0 0.216719 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_5301_74201",
    x: 74.4974,
    y: 91.093,
    width: 42.4037,
    height: 73.6799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.83627
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.59067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5301_74201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5301_74201",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.18477,
    dy: 1.79619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38858
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.29245 0 0 0 0 0.216719 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_5301_74201",
    x: 45.1458,
    y: 50.0637,
    width: 66.3842,
    height: 50.1685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.83627
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.59067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5301_74201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5301_74201",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.18477,
    dy: 1.79619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38858
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.29245 0 0 0 0 0.216719 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_5301_74201",
    x: 72.5794,
    y: 52.5222,
    width: 75.5834,
    height: 116.214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.83627
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.59067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5301_74201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5301_74201",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.18477,
    dy: 1.79619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38858
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.29245 0 0 0 0 0.216719 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_5301_74201",
    x: 67.4749,
    y: 22.3256,
    width: 68.4037,
    height: 68.4034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.83627
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.59067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5301_74201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5301_74201",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.18477,
    dy: 1.79619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38858
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.29245 0 0 0 0 0.216719 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_5301_74201",
    x: 70.2674,
    y: 41.1189,
    width: 40.3049,
    height: 32.2369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.18477,
    dy: 1.79619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.49048
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.623529 0 0 0 0 0.956863 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_di_5301_74201",
    x: 106.503,
    y: 13.1892,
    width: 36.1381,
    height: 58.8046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.83627
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.59067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5301_74201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5301_74201",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.18477,
    dy: 1.79619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38858
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.29245 0 0 0 0 0.216719 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bi_5301_74201",
    x: -2.45919,
    y: -5.39583,
    width: 82.9399,
    height: 113.284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.59239
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5301_74201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5301_74201",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.49048,
    dy: 4.49048
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38858
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.623529 0 0 0 0 0.956863 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5301_74201"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_bi_5301_74201",
    x: 8.96562,
    y: 80.6205,
    width: 41.9652,
    height: 30.5949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.59239
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5301_74201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5301_74201",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.59239,
    dy: 1.79619
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.38858
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.278431 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5301_74201"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpsellHeatmap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upsell-heatmap.17d1bedd51ceab9783ccab590345c35d.svg";